import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import Panel from 'Components/Panel/Panel';
import { useEffect, useState } from 'react';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import Button from 'Components/Button/Button';
import { useRef } from 'react';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import TotalPiecesPanel from './TotalPieces/TotalPiecesPanel';

const QuantityProducedPiecesPanel = ({
    productionDaysIdSelecteds,
    onUpdateShowQuantityProducedPiecesPanel,
    onUpdateReloadBalanceEmployee,
    showQuantityProducedPiecesPanel,
    canEditRecordsQuantityPieces,
    onUpdateReloadProductionList
}) => {
    const [selectedHour, setSelectedHour] = useState(null)
    const [totalPieceHour, setTotalPieceHour] = useState(null)
    const [amountPieceHour, setAmountPieceHour] = useState(null)
    const [efficiency, setEfficiency] = useState(null)
    const [timeGoal, setTimeGoal] = useState(null)
    const [username, setUsername] = useState(null)
    const [dtUpdate, setDtUpdate] = useState(null)

    const [recordsQuantityProducedPieces, setRecordsQuantityProducedPieces] = useState(null)
    const [recordsQuantityProducedPiecesDetail, setRecordsQuantityProducedPiecesDetail] = useState(null)
    const [selectsQuantityProducedRegisters, setSelectsQuantityProducedRegisters] = useState([])
    const [updating, setUpdating] = useState(false)

    const [totalPiecesPanelShow, setTotalPiecesPanelShow] = useState(false)
    const [reactivateQuantityProducedPiecesPanel, setReactivateQuantityProducedPiecesPanel] = useState(false)

    const attributeList = [
        { name: "selectedHour", value: selectedHour, setter: setSelectedHour },
        { name: "totalPieceHour", value: totalPieceHour, setter: setTotalPieceHour, focus: true },
        { name: "amountPieceHour", value: amountPieceHour, setter: setAmountPieceHour, focus: true },
        { name: "efficiency", value: efficiency, setter: setEfficiency },
        { name: "timeGoal", value: timeGoal, setter: setTimeGoal },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];

    const panelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
    };

    useEffect(() => {
        reloadQuantityProducedPiecesPanel()
    }, [updating]);

    useEffect(() => {
        if (reactivateQuantityProducedPiecesPanel) {
            setReactivateQuantityProducedPiecesPanel(false)
            reloadQuantityProducedPiecesPanel()
        }
    }, [reactivateQuantityProducedPiecesPanel]);

    useEffect(() => {
        if (showQuantityProducedPiecesPanel) {
            reloadQuantityProducedPiecesPanel()
        }
    }, [showQuantityProducedPiecesPanel]);

    function reloadQuantityProducedPiecesPanel() {
        if (productionDaysIdSelecteds && productionDaysIdSelecteds.length === 1) {
            getQuantityProducedRecordsGrid(productionDaysIdSelecteds[0])
        } else {
            getQuantityProducedRecordsGrid(null)
        }
    }

    async function getQuantityProducedRecordsGrid(productionDaysIdSelecteds) {
        const parameters = {
            productionDayId: productionDaysIdSelecteds ? productionDaysIdSelecteds : 0
        }
        const quantityProducedPiecesPanelGrid = await ExecuteAxios.api('get', `/production-hour/get-production-hour-grid/`, { params: parameters });
        setRecordsQuantityProducedPieces(quantityProducedPiecesPanelGrid);
        RemoveIdsNotFound.remove(quantityProducedPiecesPanelGrid, setSelectsQuantityProducedRegisters, selectsQuantityProducedRegisters)
    }

    useEffect(() => {
        if (selectsQuantityProducedRegisters.length == 1) {
            getQuantityProducedRecordsDetail(selectsQuantityProducedRegisters[0])
        }
    }, [selectsQuantityProducedRegisters, updating]);

    async function getQuantityProducedRecordsDetail(selectsQuantityProducedRegister) {
        const parameters = {
            id: selectsQuantityProducedRegister
        }
        const QuantityProducedPiecesPanelDetail = await ExecuteAxios.api('get', `/production-hour/get-production-hour-detail/`, { params: parameters });
        setRecordsQuantityProducedPiecesDetail(QuantityProducedPiecesPanelDetail);
        if (QuantityProducedPiecesPanelDetail) {
            ApplyAttributes.applyAttributes(QuantityProducedPiecesPanelDetail, attributeList)
        }
    }

    const getPanelListOrDetail = () => {
        if (!updating) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setSelectsQuantityProducedRegisters}
                    idsSelected={selectsQuantityProducedRegisters}
                    data={recordsQuantityProducedPieces}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={recordsQuantityProducedPiecesDetail}
                    attributeList={attributeList}
                />
            )
        }
    }

    const cancelFunction = () => {
        setUpdating(false)
    }

    async function putProductOperation() {
        const response = await ExecuteAxios.api('put', `/production-hour/`, {
            id: selectsQuantityProducedRegisters[0],
            amountPieceHour: amountPieceHour
        });

        if (response) {
            onUpdateReloadProductionList(true)
            onUpdateReloadBalanceEmployee(true)
        }

        return response;
    }

    const styleHistoryChangeButton = {
        width: '80px',
        float: 'right',
        color: 'red',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '30px'
    };

    function closeButton() {
        return (
            <Button
                clickMethod={() => { executeCloseMethods() }}
                buttonName={'Fechar'}
                style={styleHistoryChangeButton}
            />
        )
    }

    function executeCloseMethods() {
        onUpdateShowQuantityProducedPiecesPanel(false)
        ResetVariables.resetVariables(attributeList)
        setSelectsQuantityProducedRegisters([])
        setUpdating(false)
    }

    const totalPiecesButtonStyle = {
        width: '120px',
        float: 'right',
        color: 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '30px'
    };

    function totalPiecesButton() {
        return (
            <Button
                clickMethod={() => { executeTotalPiecesMethods() }}
                buttonName={'Total de peças'}
                style={totalPiecesButtonStyle}
            />
        )
    }

    function executeTotalPiecesMethods() {
        setTotalPiecesPanelShow(true)
    }

    return (
        <MiddlePanel isVisible={showQuantityProducedPiecesPanel}>
            <Panel style={{
                width: '780px',
                height: '550px',
                padding: '5px',
                borderRadius: '10px',
                backgroundColor: '#f5f5f5',
                border: '1px solid #ccc',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)'
            }}>
                <TotalPiecesPanel
                    productionDaysIdSelecteds={productionDaysIdSelecteds}
                    setTotalPiecesPanelShow={setTotalPiecesPanelShow}
                    totalPiecesPanelShow={totalPiecesPanelShow}
                    setReactivateQuantityProducedPiecesPanel={setReactivateQuantityProducedPiecesPanel}
                />
                <LoadingIndicator loaded={recordsQuantityProducedPieces}>
                    <Panel titlePage={'Quantidade de peças produzidas hora'}
                        style={panelListStyle}
                        canViewCRUD={true}
                        setUpdating={setUpdating}
                        putFunction={putProductOperation}
                        enableEdit={true}
                        canEdit={selectsQuantityProducedRegisters && selectsQuantityProducedRegisters.length == 1 && canEditRecordsQuantityPieces}
                        enableDelete={false}
                        cancelFunction={cancelFunction}
                        canDelete={true}
                        recordsSelected={selectsQuantityProducedRegisters}
                        resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                        inserting={false}
                        updating={updating}
                        componentRightButtons={closeButton()}
                        dataListedAttributes={recordsQuantityProducedPiecesDetail}
                        attributeList={attributeList}
                        componentLeftButtons={totalPiecesButton()}
                    >
                        {getPanelListOrDetail()}
                    </Panel>
                </LoadingIndicator>
            </Panel>
        </MiddlePanel >
    );
}

export default QuantityProducedPiecesPanel;
